import { useGlobalSettings } from '@/context/GlobalSettingsContext';
import { getTranslator } from '@/i18n';

/**
 * Hook that returns a `t(key, replacements?)` function
 * using the current language from GlobalSettingsContext.
 */
export function useTranslation() {
  const { language } = useGlobalSettings();
  return getTranslator(language);
}
